import type { SearchWorkbookTemplatesRequest, WorkbookTemplate } from "../../../../api/types/workbookRuns.types";
import type { FilterState } from "../../../common/filters/filterState";
import type { GridSortItem } from "../../../common/filters/filterTypes";

export const getWorkbookTemplatesFilterPayload = (
  filterState: FilterState<WorkbookTemplate>
): Omit<SearchWorkbookTemplatesRequest, "range"> => {
  const getSorting = (gridSortItem: GridSortItem | undefined) => {
    if (gridSortItem === undefined) {
      return undefined;
    }

    return {
      fieldId: gridSortItem.field,
      ascending: gridSortItem.sort === "asc",
    };
  };
  const sort = getSorting(filterState.sorting);

  return {
    searchTerm: filterState.search.value || undefined,
    sort,
  };
};
